export default __webpack_public_path__ + "static/media/3.d0fc5be6.jpg";